import { Routes, Route } from 'react-router-dom';
import { SiteLayout } from '@/components/layout';
import {
  LandingPage,
  ProductPage,
  BenchmarkPage,
  CudaBenchmarkPage,
  MlxBenchmarkPage,
  PricingPage,
  AboutPage,
  VisionPage,
  TermsPage,
  PrivacyPage,
  InvestorsPage,
  PitchDeckPage,
  OnePagerPage,
} from '@/pages';

export function App() {
  return (
    <SiteLayout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/product" element={<ProductPage />} />
        <Route path="/benchmark" element={<BenchmarkPage />} />
        <Route path="/benchmark/cuda" element={<CudaBenchmarkPage />} />
        <Route path="/benchmark/mlx" element={<MlxBenchmarkPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/vision" element={<VisionPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/investors" element={<InvestorsPage />} />
        {/* Direct-access investor material — deliberately absent from TopNav and MobileMenu */}
        <Route path="/pitch" element={<PitchDeckPage />} />
        <Route path="/one-pager" element={<OnePagerPage />} />
      </Routes>
    </SiteLayout>
  );
}
